<template>
    <div>
        <main class="messages" :class="{'messages--selected': currentCompanyType}">
            <aside class="messages__sidebar">
                <div class="form-search">
                    <input placeholder="Search" type="text" v-model="searchStr" v-debounce:500="search">
                </div>

                <ul class="messages__list">
                    <li v-for="(company, index) in companies" :key="index"
                        :class="{messages__list__active: (currentCompanyType == company.type && currentCompanyId == company.id), messages__list__unread: $store.state.newMessages.indexOf(company.type + '-' + company.id) >= 0}"
                        @click="setCurrentCompany(index)"
                    >
                        <div class="d-flex">
                            <div class="image-block">
                                <img :src="LogoHelper.getLogo(company.logo)" alt="">
                            </div>
                        
                            <h5 class="heading5">{{ company.name }}</h5>
                        </div>
                    </li>
                </ul>
            </aside>

            <section class="messages__profile" v-if="hasContacts == false">
                <div class="messages__empty" v-if="$store.state.user.company_type == 'enterprise'">
                    <h4 class="heading4 messages__empty__title">Collaborate with VCs and accelerators</h4>

                    <p>Connect with ecosystems and send messages here to collaborate on projects!</p>

                    <a class="btn btn-primary btn-lg" v-if="$store.state.user.enterprise_type == 'paid'" href="/ecosystems" target="_blank">Find Ecosystems</a>
                    <a class="btn btn-primary btn-lg" v-else @click="$refs.addEcosystem.open()">Invite VCs / accelerators and other ecosystems</a>

                    <add-connection
                        company-type="ecosystem"
                        ref="addEcosystem"
                    >
                    </add-connection>
                </div>

                <div class="messages__empty messages__empty--eco" v-if="$store.state.user.company_type == 'ecosystem'">
                    <h4 class="heading4 messages__empty__title">Collaborate with Enterprises</h4>

                    <p>Connect with enterprises and send messages here to collaborate on projects!</p>

                    <a class="btn btn-primary btn-lg" href="/connections/enterprises" target="_blank">Find Enterprises</a>
                </div>
            </section>
            
            <section class="messages__profile" v-else>
                <header v-if="currentCompanyIndex > -1" class="messages__profile__header">
                    <div class="d-flex align-items-center">
                        <div class="image-block">
                            <img :src="LogoHelper.getLogo(companies[currentCompanyIndex].logo)" alt="">
                        </div>
                        <h4 class="heading4">{{ companies[currentCompanyIndex].name }}</h4>
                    </div>

                    <template v-if="currentCompanyType == 'ecosystem'">
                        <a :href="'/ecosystems/' + currentCompanyId" class="btn btn-bordered" target="_blank">View Profile</a>
                    </template>
                </header>

                <div class="messages__empty" v-if="hasMessages == false && currentCompanyIndex >= 0 && companies[currentCompanyIndex].connected">
                    You are now connected on SwitchPitch, Send a message to start a conversation with CompanyName.
                </div>

                <div class="chat" v-if="hasMessages == true">

                    <div v-for="(message, index) in messages" :key="index">

                        <div v-if="message.type == 'date'" class="chat__date">{{dateHelper.decodeDate(message.text, ['month-str', 'no-current-year'])}}</div>

                        <div v-else class="chat__item" :class="{'chat__item--author': message.type == 'sent'}">
                            <div class="chat__author">
                                <Avatar
                                    :username="message.user_name"
                                    :src="message.user_logo"
                                    :size="54">
                                </Avatar>
                            </div>

                            <div class="chat__content">
                                <header class="chat__header">
                                    <span :class="{deleted: message.user_deleted}">{{ message.user_name }}<span v-if="message.user_deleted"> (D)</span></span>
                                    <time class="chat__time">{{ message.date }}</time>
                                </header>
                                <div class="chat__body">
                                    <template v-if="!message.request && !message.tracker">
                                        {{message.text}}
                                    </template>

                                    <template v-if="message.request">
                                        <template v-if="message.request.status == 'new'">
                                            <template v-if="message.type == 'received'">
                                                <p>{{message.request.author_name}} has invited you to connect with {{ message.request.company_name }}</p>
                                                <p v-if="message.request.company_type == 'ecosystem'">Connecting with Ecosystems allows them to help you find and connect with
                                                    relevant startups they're affiliated with. You will also be able to chat and collaborate with
                                                    them in this messaging space.</p>

                                                <footer class="chat__footer mt-3">
                                                    <button class="btn btn-red" @click="changeInvitationStatus(message.id, 'rejected')">Reject Invite</button>

                                                    <button class="btn btn-primary btn-lg" @click="changeInvitationStatus(message.id, 'accepted')">Accept Invite</button>
                                                </footer>
                                            </template>
                                            <template v-else>
                                                <p>Invitation sent</p>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <p>Invitation {{message.request.status}}</p>
                                        </template>
                                    </template>

                                    <template v-if="message.tracker">
                                        <template v-if="message.type == 'received'">
                                            <p>{{message.tracker.author_name}} has invited you to collaborate on a project. This will allow your company to add startups from your ecosystem that
                                                match {{message.tracker.company_name}}'s needs. See project details below:
                                            </p>
                                            <br>
                                            <p>
                                                <b>{{message.tracker.name}}</b>
                                            </p>
                                            <p v-html="message.tracker.description"></p>

                                            <footer class="chat__footer mt-3">
                                                <a :href="'/projects/' + message.tracker.id" target="_blank" class="btn btn-primary btn-lg">Go To Project</a>
                                            </footer>
                                        </template>
                                        <template v-else>
                                            You sent {{message.tracker.ecosystem}} an invite to add startups to the project {{message.tracker.name}}.
                                            <footer class="chat__footer mt-3">
                                                <a :href="'/trackers/' + message.tracker.id" target="_blank" style="background-color: white" class="btn btn-lg">Go To Project</a>
                                            </footer>
                                        </template>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <footer v-if="currentCompanyIndex > -1 && companies[currentCompanyIndex].connected" class="messages__profile__footer">
                    <div class="messages__field">
                        <input type="text" v-model="newMessage" @keyup.enter="send" />
                        <button @click="send">Send</button>
                    </div>
                    <button v-if=false class="messages__attach"></button>
                </footer>
            </section>
        </main>
    </div>
</template>

<script>
import messages from '@/services/messages.service'
import Avatar from "vue-avatar";
import addConnection from "@/components/connections/AddConnection";

export default {
    components: {
        Avatar,
        addConnection
    },

    data() {
        return {
            currentCompanyIndex: -1,
            currentCompanyType: '',
            currentCompanyId: '',
            companies: [],
            messages: [],
            hasMessages: null,
            hasContacts: null,
            newMessage: "",
            searchStr: "",
            firstLoad: true,
            storeWatcher: null,

            timer: null,
            showEmpty: this.$route.query['show_empty'] ? true : false,
        }
    },

    mounted() {
        this.getCompanies()

        this.timer = setInterval(() => {
            this.getMessages()
        }, 5000)

        this.storeWatcher = this.$store.watch(state => {
            state.newMessages.forEach(item => {
                let parts = item.split('-')
                let index = this.arrayHelper.findIndexByColumnValue(this.companies, ['type', 'id'], [parts[0], parts[1]])
                if (index < 0) {
                    this.getCompanies()
                    return
                }
            })
        })
    },

    beforeDestroy() {
        clearInterval(this.timer)
        this.storeWatcher()
    },

    watch: {
        currentCompanyType() {
            this.messages = []
        },
        currentCompanyId() {
            this.messages = []
        },
    },

    methods: {
        getCompanies() {
            messages.getCorrespondingCompanies(this.searchStr).then(response => {
                if (this.showEmpty) {
                    response.data = []
                }

                this.hasContacts = response.data.length > 0

                if (this.currentCompanyIndex >= 0) {
                    let index = this.arrayHelper.findIndexByColumnValue(response.data, ['type', 'id'], [this.currentCompanyType, this.currentCompanyId])

                    if (index < 0) {
                        this.currentCompanyIndex = -1
                        this.currentCompanyType = ''
                        this.currentCompanyId = ''
                    }
                }

                this.companies = response.data

                if (this.$route.query.company_type && this.$route.query.company_id) {
                    let index = this.arrayHelper.findIndexByColumnValue(this.companies, ['type', 'id'], [this.$route.query.company_type, this.$route.query.company_id])

                    if (index >= 0) {
                        this.setCurrentCompany(index)
                    }
                }
                else if (this.companies.length) {
                    this.setCurrentCompany(0)
                }
            })
        },

        setCurrentCompany(index) {
            this.hasMessages = null
            this.currentCompanyIndex = index
            this.currentCompanyType = this.companies[index].type
            this.currentCompanyId = this.companies[index].id
            this.companies[index].unread = false
            this.getMessages()
        },

        getMessages() {
            if (this.currentCompanyType && this.currentCompanyId) {
                let checkConnection = !this.companies[this.currentCompanyIndex].connected

                messages.getMessages(this.currentCompanyType, this.currentCompanyId, checkConnection, this.searchStr).then(response => {
                    this.messages = response.data.messages
                    this.hasMessages = response.data.has_messages

                    if (checkConnection && response.data.connected) {
                        this.companies[this.currentCompanyIndex].connected = true
                    }
                })
            }
        },

        search() {
            this.getCompanies()
            this.getMessages()
        },

        send() {
            if (this.newMessage.length) {
                messages.sendMessage(this.currentCompanyType, this.currentCompanyId, this.newMessage).then(() => {
                    this.getMessages()
                    this.newMessage = ""
                })
            }
        },

        changeInvitationStatus(messageId, status) {
            let question
            if (status == 'accepted') {
                question = "Accept Invitation?"
            }
            else {
                question = "Reject Invitation?"
            }

            if (confirm(question)) {
                messages.changeInvitationStatus(messageId, status).then(() => {
                    if (status == 'accepted') {
                        this.companies[this.currentCompanyIndex].connected = true
                        this.$store.commit('updateUserData')
                    }
                    this.getMessages()
                })
            }
        }
    }
}
</script>

<style scoped>

</style>